import Courseware from '@/components/video/Courseware'
import Live from '@/components/video/Live'
import Reply from '@/components/video/Reply'
import Classify from '@/components/video/Classify'

let video = [{
  path: '/video/courseware',
  name: 'Courseware',
  component: Courseware
},{
  path: '/video/live',
  name: 'Live',
  component: Live
},{
  path: '/video/reply',
  name: 'Reply',
  component: Reply
},{
  path: '/video/classify',
  name: 'Classify',
  component: Classify
}]

export default video



// WEBPACK FOOTER //
// ./src/router/video.js